export default {
  overcapGain: 'Income is reduced to {0}% due to overcap',
  overcapNoGain: 'No income due to overcap',
  benefitLoss: 'Buying this results in the loss of benefits',
  gainTimerNeeded: 'Can afford in {0}',
  capTimerNeeded: 'Capacity reached in {0}',
  overcapTimerNeeded: 'Next capacity level reached in {0}',

  // Premium currencies
  gem_ruby: {
    name: 'Ruby',
    description: 'A shiny red gem that can be exchanged for powerful permanent upgrades'
  },
  gem_emerald: {
    name: 'Emerald',
    description: 'A dull green gem that can be used to buy various improvements. Your villagers seem to like it'
  },
  gem_sapphire: {
    name: 'Sapphire',
    description: 'A dark blue gem that can be used to buy consumables to help you progress faster'
  },
  gem_amethyst: {
    name: 'Amethyst',
    description: 'This beautiful purple gem can be used to buy themes or other cosmetic items'
  },
  gem_topaz: {
    name: 'Topaz',
    description: 'A yellow gem that can be used to improve your performance or participate in events. During large events, topaz cannot be gained from the gem generator. You will receive an event-specific currency instead'
  },
  gem_diamond: {
    name: 'Diamond',
    description: ''
  },
  gem_onyx: {
    name: 'Onyx',
    description: ''
  },

  // Event currencies
  event_wax: {
    name: 'Wax',
    description: 'Natural wax used to make candles'
  },
  event_humus: {
    name: 'Humus',
    description: 'Your flowers love this fresh and fertile soil'
  },
  event_cloud: {
    name: 'Cloud',
    description: 'A tiny cloud, captured in a bottle'
  },
  event_cocktail: {
    name: 'Cocktail',
    description: 'You are tempted to drink these yourself, but they are an excellent source of motivation for your builders'
  },
  event_magic: {
    name: 'Magic',
    description: 'Magic is slowly consumed to convert your other currencies into magical currencies. The more magic you have, the faster the conversion process. Magical currencies can be identified by their unusual icon. To return them to their regular version, just hover over them and you\'ll get ingredients in return'
  },
  event_snowball: {
    name: 'Snowball',
    description: 'Catch!'
  },
  event_cindersToken: {
    name: 'Cinders token',
    description: 'Reward for gaining a certain amount of light'
  },
  event_bloomToken: {
    name: 'Bloom token',
    description: 'Reward for reaching new tier records on flower types'
  },
  event_weatherChaosToken: {
    name: 'Weather chaos token',
    description: 'Reward for reaching new size records on fish'
  },
  event_summerFestivalToken: {
    name: 'Summer festival token',
    description: 'Reward for completing quests'
  },
  event_nightHuntToken: {
    name: 'Night hunt token',
    description: 'Reward for leveling up potions or succeeding in new rituals'
  },
  event_snowdownToken: {
    name: 'Snowdown token',
    description: 'Reward for winning snowball fights'
  },
  event_light: {
    name: 'Light',
    description: 'Burning brighter'
  },
  event_soot: {
    name: 'Soot',
    description: 'Left behind from burnt candles'
  },
  event_blossom: {
    name: 'Blossom',
    description: 'They are beautiful, but they all look the same'
  },
  event_algae: {
    name: 'Algae',
    description: 'Green and slimy'
  },
  event_driftwood: {
    name: 'Driftwood',
    description: 'You don\'t know where it came from, but it still looks usable'
  },
  event_plastic: {
    name: 'Plastic',
    description: 'Why is there so much trash in the seas?'
  },
  event_slime: {
    name: 'Slime',
    description: 'And you thought algae was slimy'
  },
  event_log: {
    name: 'Log',
    description: 'A basic construction material'
  },
  event_stoneBlock: {
    name: 'Stone block',
    description: 'Cut from the mountain'
  },
  event_coconut: {
    name: 'Coconut',
    description: 'Hard to crack'
  },
  event_shell: {
    name: 'Shell',
    description: 'Shells you found on a beach'
  },
  event_music: {
    name: 'Music',
    description: 'You call that music?'
  },
  event_sand: {
    name: 'Sand',
    description: 'Sand, as far as the eye can see'
  },
  event_freshWater: {
    name: 'Fresh water',
    description: 'Fresh and filtered'
  },
  event_coal: {
    name: 'Coal',
    description: 'A resource often used to make fire to cook food'
  },
  event_metalPart: {
    name: 'Metal part',
    description: 'Some call it trash, others call it treasure'
  },
  event_pearl: {
    name: 'Pearl',
    description: 'A rare pearl, found in a shell'
  },
  event_salt: {
    name: 'Salt',
    description: 'Salty?'
  },
  event_pepper: {
    name: 'Pepper',
    description: 'Perfect when you need some spice'
  },
  event_honey: {
    name: 'Honey',
    description: 'How sweet'
  },
  event_vegetable: {
    name: 'Vegetable',
    description: 'Nutritious and possibly delicious'
  },
  event_citrusFruit: {
    name: 'Citrus fruit',
    description: 'Sweet and sour'
  },
  event_rawFish: {
    name: 'Raw fish',
    description: 'Fresh from the ocean'
  },
  event_cookedFish: {
    name: 'Cooked fish',
    description: 'This would go great with some lemon'
  },
  event_rawMeat: {
    name: 'Raw meat',
    description: 'Fresh from the forest'
  },
  event_cookedMeat: {
    name: 'Cooked meat',
    description: 'Just needs some salt and pepper'
  },
  event_solidPlate: {
    name: 'Solid plate',
    description: 'Common building material made from wood and stone'
  },
  event_sandstone: {
    name: 'Sandstone',
    description: 'Looks like sand, but behaves like stone'
  },
  event_hardSteel: {
    name: 'Hard steel',
    description: 'Stainless and even harder than regular steel'
  },
  event_compositePlate: {
    name: 'Composite plate',
    description: 'You decided to merge everything together and it... works!'
  },
  event_coconutSalad: {
    name: 'Coconut salad',
    description: 'Fresh and simple'
  },
  event_saltyShell: {
    name: 'Salty shell',
    description: 'It is... an acquired taste'
  },
  event_lemonCandy: {
    name: 'Lemon candy',
    description: 'Kids love these'
  },
  event_steak: {
    name: 'Steak',
    description: 'Perfectly cooked'
  },
  event_fishSticks: {
    name: 'Fish sticks',
    description: 'A timeless classic'
  },
  event_essence: {
    name: 'Essence',
    description: 'A strange liquid, but it looks powerful'
  },
  event_lavender: {
    name: 'Lavender',
    description: 'Found in the forest'
  },
  event_mapleLeaf: {
    name: 'Maple leaf',
    description: 'Strange, there are no maple trees in sight'
  },
  event_fourLeafClover: {
    name: 'Four-leaf clover',
    description: 'Lucky!'
  },
  event_charredSkull: {
    name: 'Charred skull',
    description: 'These bones are not only burnt, but look extremely old as well'
  },
  event_mysticalWater: {
    name: 'Mystical water',
    description: 'It looks like regular water, but a little brighter'
  },
  event_cheese: {
    name: 'Cheese',
    description: 'Most people would eat this, but it also has great magical uses'
  },
  event_spiderWeb: {
    name: 'Spider web',
    description: 'No spider inside, looks like it\'s yours to take'
  },
  event_strangeEgg: {
    name: 'Strange egg',
    description: 'What is this? What creature could this belong to? Well, into the mix you go!'
  },
  event_puzzlePiece: {
    name: 'Puzzle piece',
    description: 'It can solve logical puzzles, but can it also solve magical ones?'
  },
  event_wizardHat: {
    name: 'Wizard hat',
    description: 'Lookin\' fancy!'
  },
  event_cactus: {
    name: 'Cactus',
    description: 'Don\'t touch it'
  },
  event_feather: {
    name: 'Feather',
    description: 'Not a heavyweight'
  },
  event_dough: {
    name: 'Dough',
    description: 'Why eat the cookies when you can eat the dough?'
  },
  event_cinnamon: {
    name: 'Cinnamon',
    description: 'What would winter be without cinnamon?'
  },
  event_sapling: {
    name: 'Sapling',
    description: 'Pine tree saplings. With enough time, these can grow into massive trees'
  },
  event_water: {
    name: 'Water',
    description: 'Clean and cold tap water'
  },
  event_snow: {
    name: 'Snow',
    description: 'It\'s cold, it\'s everywhere and with enough you could build an entire snowman'
  },
  event_yarn: {
    name: 'Yarn',
    description: 'Keeping everyone warm and comfortable'
  },

  // Feature currencies
  mining_scrap: {
    name: 'Scrap',
    description: 'For some reason, the underground rocks are full of scrap! But this can also be a good thing, scrap is versatile and can be used to create almost anything'
  },
  mining_oreAluminium: {
    name: 'Aluminium ore',
    description: 'Finally, something that is not scrap. In its unrefined form its use is limited, but that does not mean useless'
  },
  mining_oreCopper: {
    name: 'Copper ore',
    description: 'Another one of the missing ores. This one seems to yield better results than the previous one. How many more are down here?'
  },
  mining_oreTin: {
    name: 'Tin ore',
    description: 'A light material is a welcome change to the darkness at these depths. The hole to the surface is getting hard to see'
  },
  mining_oreIron: {
    name: 'Iron ore',
    description: 'A hard and sturdy material. Parts of the scrap you found look similar to this one'
  },
  mining_oreTitanium: {
    name: 'Titanium ore',
    description: 'Compared to iron, this one seems to be indestructible. This could be helpful to construct a few things where other ores would not have been stable enough'
  },
  mining_orePlatinum: {
    name: 'Platinum ore',
    description: 'This ore appears to be very beautiful if you polish it a bit. Let\'s hope it is not only beautiful, but useful as well'
  },
  mining_oreIridium: {
    name: 'Iridium ore',
    description: 'Irid... what? You never heard of this one before, can it even be used for anything?'
  },
  mining_oreOsmium: {
    name: 'Osmium ore',
    description: ''
  },
  mining_oreLead: {
    name: 'Lead ore',
    description: ''
  },
  mining_granite: {
    name: 'Granite',
    description: 'Huge blocks of granite cut from the underground. Surprisingly, there is no scrap in them'
  },
  mining_salt: {
    name: 'Salt',
    description: 'This salt is not made for eating, it tastes bitter. Better use it to smelt your ores'
  },
  mining_coal: {
    name: 'Coal',
    description: 'This resource seems to be scarce, after mining it you couldn\'t find any more nearby like with the ores'
  },
  mining_sulfur: {
    name: 'Sulfur',
    description: 'Bright and yellow'
  },
  mining_niter: {
    name: 'Niter',
    description: 'Another rare resource, this one is limited as well'
  },
  mining_obsidian: {
    name: 'Obsidian',
    description: 'Beautiful purple shards, they look fragile'
  },
  mining_deeprock: {
    name: 'Deeprock',
    description: ''
  },
  mining_glowshard: {
    name: 'Glowshard',
    description: ''
  },
  mining_barAluminium: {
    name: 'Aluminium bar',
    description: 'The first of many'
  },
  mining_barBronze: {
    name: 'Bronze bar',
    description: 'More than the sum of its parts'
  },
  mining_barSteel: {
    name: 'Steel bar',
    description: 'Reinforced iron'
  },
  mining_barTitanium: {
    name: 'Titanium bar',
    description: 'Extremely durable and resistant'
  },
  mining_barShiny: {
    name: 'Shiny bar',
    description: 'This one is not very sharp or durable, but seems to have other uses'
  },
  mining_barIridium: {
    name: 'Iridium bar',
    description: 'What strange properties does this one have...'
  },
  mining_barDarkIron: {
    name: 'Dark iron bar',
    description: ''
  },
  mining_ember: {
    name: 'Ember',
    description: 'Careful, it\'s still hot!'
  },
  mining_resin: {
    name: 'Resin',
    description: 'Extremely sticky resin that is used to make pickaxes last longer'
  },
  mining_crystalGreen: {
    name: 'Green crystal',
    description: 'These crystals look amazing! You would have never found them without your depth dweller'
  },
  mining_smoke: {
    name: 'Smoke',
    description: 'It\'s getting hard to breathe in here, this smoke is heavier than regular smoke'
  },
  mining_helium: {
    name: 'Helium',
    description: 'Also known as real-life voice changer'
  },
  mining_neon: {
    name: 'Neon',
    description: 'Everything looks so bright...'
  },
  mining_argon: {
    name: 'Argon',
    description: ''
  },
  mining_krypton: {
    name: 'Krypton',
    description: ''
  },
  mining_xenon: {
    name: 'Xenon',
    description: ''
  },
  mining_radon: {
    name: 'Radon',
    description: ''
  },
  mining_crystalYellow: {
    name: 'Yellow crystal',
    description: 'These crystals look amazing as well! Good thing you already have your depth dweller'
  },
  village_coin: {
    name: 'Gold coin',
    description: 'Coins earned by selling food to your villagers'
  },
  village_copperCoin: {
    name: 'Copper coin',
    description: 'Coins earned by selling crafted items to your villagers'
  },
  village_wood: {
    name: 'Wood',
    description: 'Logs harvested from nearby trees'
  },
  village_plantFiber: {
    name: 'Plant fiber',
    description: 'Grass, small plants, leaves, doesn\'t matter. They are all useful'
  },
  village_stone: {
    name: 'Stone',
    description: 'Small rocks your creatures collected'
  },
  village_metal: {
    name: 'Metal',
    description: 'Your creatures found this metal by digging underground. Seems like the ground beneath this village isn\'t full of scrap'
  },
  village_gem: {
    name: 'Gem',
    description: 'Precious and shiny, this gem was found by expert miners using explosives'
  },
  village_water: {
    name: 'Water',
    description: 'Just plain and simple water'
  },
  village_vegetable: {
    name: 'Vegetable',
    description: 'Fresh vegetables, grown in your local village'
  },
  village_fruit: {
    name: 'Fruit',
    description: 'Sweet and juicy fruit, the villagers love these'
  },
  village_fish: {
    name: 'Fish',
    description: 'These fish are from the river next to your village'
  },
  village_grain: {
    name: 'Grain',
    description: 'Grain from plants grown in the village. You think this should be processed before eating it, but the villagers don\'t care'
  },
  village_knowledge: {
    name: 'Knowledge',
    description: 'Observe and learn'
  },
  village_science: {
    name: 'Science',
    description: 'By conducting experiments under scientific standards, you can gather data that allows you to understand this world better'
  },
  village_joy: {
    name: 'Joy',
    description: 'Gain joy by reaching a happiness value of over 125%. More happiness above that value generates even more joy'
  },
  village_glass: {
    name: 'Glass',
    description: 'Be careful, don\' drop it!'
  },
  village_faith: {
    name: 'Faith',
    description: 'Your villagers are certain that things will be better in the future'
  },
  village_blessing: {
    name: 'Blessing',
    description: 'The hopes of your villagers turned out to be true! Things are better in the future! It will get easier over time!'
  },
  village_shares: {
    name: 'Shares',
    description: 'Invest to make more money!'
  },
  village_offering: {
    name: 'Offering',
    description: 'A mysterious offering that required a resource sacrifice'
  },
  village_hardwood: {
    name: 'Hardwood',
    description: 'These logs are gained from giant trees that need centuries to grow. Their wood is hard, but still elastic'
  },
  village_oil: {
    name: 'Oil',
    description: 'A flexible and precious resource'
  },
  village_marble: {
    name: 'Marble',
    description: 'This beautiful piece of stone is a common choice for more luxorious buildings'
  },
  village_meat: {
    name: 'Meat',
    description: 'These cows surely had a wonderful life... right?'
  },
  village_loot0: {
    name: 'Common loot',
    description: 'Has to do for now...'
  },
  village_loot1: {
    name: 'Uncommon loot',
    description: 'Slightly better, but we can do more!'
  },
  village_loot2: {
    name: 'Rare loot',
    description: 'Finally something decent'
  },
  village_loot3: {
    name: 'Epic loot',
    description: 'Now it\'s getting good'
  },
  village_loot4: {
    name: 'Legendary loot',
    description: 'LEGENDARY!'
  },
  village_loot5: {
    name: 'Mythical loot',
    description: 'And you thought these were lost forever'
  },
  village_acidVial: {
    name: 'Acid vial',
    description: 'Be careful!'
  },
  village_snowflake: {
    name: 'Snowflake',
    description: ''
  },
  village_chiliBundle: {
    name: 'Chili bundle',
    description: ''
  },
  village_gears: {
    name: 'Gears',
    description: ''
  },
  horde_bone: {
    name: 'Bone',
    description: 'Skeletal remains of the enemies you have slain'
  },
  horde_monsterPart: {
    name: 'Monster part',
    description: 'A disgusting organ that can be found at zone 10 or higher when enemies stop appearing'
  },
  horde_corruptedFlesh: {
    name: 'Corrupted flesh',
    description: 'This does not look healthy at all. The entire piece of flesh is purple and violently pulsing'
  },
  horde_mysticalShard: {
    name: 'Mystical shard',
    description: 'Filled with untapped power'
  },
  horde_soulCorrupted: {
    name: 'Corrupted soul',
    description: 'These souls are corrupted, but not all hope is lost. They can still be saved with a complex ritual'
  },
  horde_soulEmpowered: {
    name: 'Empowered soul',
    description: 'Formerly corrupted souls that were purified and strengthened by a complex ritual'
  },
  horde_courage: {
    name: 'Courage',
    description: 'Bravery is a much needed virtue when facing a neverending horde'
  },
  horde_crown: {
    name: 'Crown',
    description: 'They used to rule the towers, but are now dethroned'
  },
  horde_towerKey: {
    name: 'Tower key',
    description: 'A rare key that allows you to access a tower'
  },
  horde_blood: {
    name: 'Blood',
    description: 'Eww!'
  },
  horde_lockpick: {
    name: 'Lockpick',
    description: 'Allows you to receive trinkets from already defeated bosses. Exclusive to the pirate'
  },
  farm_vegetable: {
    name: 'Vegetable',
    description: 'Eat your veggies!'
  },
  farm_berry: {
    name: 'Berry',
    description: 'The fertile soil on this farm gives the berries an intense taste'
  },
  farm_grain: {
    name: 'Grain',
    description: 'Storing all your grain in one location is fine, just keep the rats away'
  },
  farm_flower: {
    name: 'Flower',
    description: 'You could spend hours just looking at these flowers'
  },
  farm_gold: {
    name: 'Gold',
    description: 'Small nuggets of gold that were buried in the soil'
  },
  farm_seedHull: {
    name: 'Seed hull',
    description: 'An empty hull from a plant, the seed seems to be missing'
  },
  farm_grass: {
    name: 'Grass',
    description: 'This seems unnatural, grass shouldn\'t grow on crops'
  },
  farm_petal: {
    name: 'Petal',
    description: 'These petals grow on all flowers, but you only collect the most beautiful ones'
  },
  farm_bug: {
    name: 'Bug',
    description: 'Your plants have attracted all kinds of bugs. Collecting them is the hard part'
  },
  farm_butterfly: {
    name: 'Butterfly',
    description: 'Light and beautiful, but hard to catch'
  },
  farm_ladybug: {
    name: 'Ladybug',
    description: 'They may be small, but if you are lucky, you can find these in larger groups'
  },
  farm_spider: {
    name: 'Spider',
    description: 'These creatures may seem scary, but they help with keeping other insects in check'
  },
  farm_bee: {
    name: 'Bee',
    description: 'Bees are a common sight on a garden. Don\'t bother them, just let them collect their nectar'
  },
  farm_mysteryStone: {
    name: 'Mystery stone',
    description: 'What is this? What uses does it have?'
  },
  farm_goldenPetal: {
    name: 'Golden petal',
    description: 'This extremely rare petal can only be found on roses. Rumors say the roses with these petals look darker than others'
  },
  farm_smallSeed: {
    name: 'Small seed',
    description: ''
  },
  gallery_beauty: {
    name: 'Beauty',
    description: 'This painting only gets more beautiful the more time you spend on it'
  },
  gallery_converter: {
    name: 'Converter',
    description: 'Create new colors, or existing ones'
  },
  gallery_inspiration: {
    name: 'Inspiration',
    description: 'Unlimited possibilities'
  },
  gallery_package: {
    name: 'Package',
    description: 'What\'s inside? Nobody knows! Like a little mystery'
  },
  gallery_red: {
    name: 'Red paint',
    description: 'Paint with passion'
  },
  gallery_redDrum: {
    name: 'Red drum',
    description: 'An entire drum filled with red paint'
  },
  gallery_orange: {
    name: 'Orange paint',
    description: 'New colors, new worlds'
  },
  gallery_orangeDrum: {
    name: 'Orange drum',
    description: 'This drum is filled with orange paint'
  },
  gallery_yellow: {
    name: 'Yellow paint',
    description: 'An easy way to get attention'
  },
  gallery_yellowDrum: {
    name: 'Yellow drum',
    description: 'This drum is easy to see'
  },
  gallery_green: {
    name: 'Green paint',
    description: 'Looks toxic, but isn\'t'
  },
  gallery_greenDrum: {
    name: 'Green drum',
    description: 'Just like the drums next to that nuclear reactor'
  },
  gallery_blue: {
    name: 'Blue paint',
    description: 'So calm, this will be a great addition to your painting'
  },
  gallery_blueDrum: {
    name: 'Blue drum',
    description: 'Just like the other ones, but it\'s blue'
  },
  gallery_purple: {
    name: 'Purple paint',
    description: 'Mysterious and unknown'
  },
  gallery_purpleDrum: {
    name: 'Purple drum',
    description: ''
  },
  "gallery_deep-orange": {
    name: 'Red-orange paint',
    description: 'This color looks new, but also familiar'
  },
  "gallery_deep-orangeDrum": {
    name: 'Red-orange drum',
    description: ''
  },
  gallery_amber: {
    name: 'Golden paint',
    description: ''
  },
  gallery_amberDrum: {
    name: 'Golden drum',
    description: ''
  },
  "gallery_light-green": {
    name: 'Light green paint',
    description: ''
  },
  "gallery_light-greenDrum": {
    name: 'Light green drum',
    description: ''
  },
  gallery_teal: {
    name: 'Teal paint',
    description: ''
  },
  gallery_tealDrum: {
    name: 'Teal drum',
    description: ''
  },
  "gallery_light-blue": {
    name: 'Light blue paint',
    description: ''
  },
  "gallery_light-blueDrum": {
    name: 'Light blue drum',
    description: ''
  },
  gallery_pink: {
    name: 'Pink paint',
    description: ''
  },
  gallery_pinkDrum: {
    name: 'Pink drum',
    description: ''
  },
  gallery_motivation: {
    name: 'Motivation',
    description: ''
  },
  gallery_mysteryShape: {
    name: 'Mystery shape',
    description: 'What is this shape? It looks strange, like it doesn\'t belong in this dimension'
  },
  gallery_circle: {
    name: 'Circle',
    description: ''
  },
  gallery_rectangle: {
    name: 'Rectangle',
    description: ''
  },
  gallery_triangle: {
    name: 'Triangle',
    description: 'Careful, those are dangerous'
  },
  gallery_star: {
    name: 'Star',
    description: ''
  },
  gallery_ellipse: {
    name: 'Ellipse',
    description: ''
  },
  gallery_heart: {
    name: 'Heart',
    description: '<3'
  },
  gallery_square: {
    name: 'Square',
    description: ''
  },
  gallery_octagon: {
    name: 'Octagon',
    description: ''
  },
  gallery_pentagon: {
    name: 'Pentagon',
    description: 'It\'s a shape, not a building'
  },
  gallery_hexagon: {
    name: 'Hexagon',
    description: ''
  },
  gallery_cash: {
    name: 'Cash',
    description: 'Easy money!'
  },
  school_book: {
    name: 'Book',
    description: 'It\'s hard to carry these heavy books'
  },
  school_goldenDust: {
    name: 'Golden dust',
    description: 'It emits a strange energy, as if it could change time itself'
  },
  school_examPass: {
    name: 'Exam pass',
    description: 'Strange, we didn\'t need them at our old school. Here they are needed to take an exam'
  },
  card_shinyDust: {
    name: 'Shiny dust',
    description: ''
  },
  treasure_fragment: {
    name: 'Fragment',
    description: 'Broken pieces of treasure'
  }
};
